import { parsePhoneNumberFromString } from 'libphonenumber-js'

export const duration = (seconds: number) => {
  const date = new Date(0)
  date.setSeconds(seconds)

  let str = date.toISOString().substr(11, 8)

  return str.startsWith('00:') ? str.substr(3) : str
}

export const formatPhoneNumber = (number: string) => {
  let numberToParse = number

  if (numberToParse.length == 9) {
    numberToParse = '+48' + numberToParse
  }

  if (!numberToParse.startsWith('+') && numberToParse.length >= 8) {
    numberToParse = '+' + numberToParse
  }

  const parsed = parsePhoneNumberFromString(numberToParse)

  return parsed ? parsed.formatInternational() : number
}

String.prototype.removeAccents = function () {
  return this.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ł/, 'l')
    .replace(/Ł/, 'L')
}

String.prototype.escapeRegExp = function () {
  return this.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const shorten = (text: string, length: number) => {
  if (text.length > length) {
    return text.substr(0, length).trim() + '...'
  }

  return text
}

// currently not used
export const escapeHtml = (text: string) => {
  var map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  }

  return text.replace(/[&<>"']/g, function (m) {
    // @ts-ignore
    return map[m]
  })
}
